import React from "react";
import { Navigate, useParams } from "react-router-dom";
import AudienceBuilderV2 from "../../components/builder-v2/AudienceBuilderV2";
import { getSession } from "../../services/auth";
import { isReadOnly } from "../../utilities/permissions";

function BuilderV2Edit() {
	const params = useParams();
	const cohortId = params.id ?? null;

	// ASB-4030. A read-only user reaching this URL — a shared link, a bookmark, browser
	// history — would otherwise get an editable criteria builder and a Save the API
	// refuses. Send them to the view page; `replace` so Back does not bounce them here.
	//
	// The guard is here and not inside AudienceBuilderV2, which is where the modeled and
	// signal pages put theirs, because the same placement would not work in this one.
	// Those two decide the role and fetch the cohort in a single function, so returning
	// early means nothing editable is ever populated. This component splits them across
	// independent mount effects, and its editable form is gated on `mode === "view"`
	// rather than on the role — so an in-component redirect still paints an interactive,
	// Save-enabled builder for a frame and still issues the cohort fetch. Returning
	// before it mounts is the only placement here that actually satisfies "no editable
	// control rendered on the way".
	//
	// getSession() returns null for a missing or expired token and isReadOnly(undefined)
	// is true, so no session redirects too, rather than falling through to the editor.
	if (cohortId && isReadOnly(getSession()?.role_id)) {
		return <Navigate to={`/audience-builder-v2/view/${cohortId}`} replace />;
	}

	return <AudienceBuilderV2 mode="edit" cohortId={cohortId} />;
}

export default BuilderV2Edit;
